import Wide from './Wide';

const EventCard = { Wide };

export default EventCard;
